import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { Adres } from '../../../models/adres';
import { PreviewDataType } from '../../../enums/preview-data-type.enum';

@Component({
  selector: 'app-preview-address',
  imports: [PreviewDataWrapperComponent],
  templateUrl: './preview-address.component.html',
  styleUrl: './preview-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewAddressComponent {
  public address = input<Adres>();
  protected readonly PreviewDataType = PreviewDataType;
}
